import * as React from 'react';
export interface LayoutEditorGuard { dirty: boolean; busy: boolean; }
export const LayoutEditorGuardContext = React.createContext<(guard: LayoutEditorGuard) => void>(() => {});
export function useLayoutEditorGuard(dirty: boolean, busy: boolean) {
  const update = React.useContext(LayoutEditorGuardContext);
  React.useLayoutEffect(() => { update({ dirty, busy }); return () => update({ dirty: false, busy: false }); }, [dirty, busy, update]);
}
